// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep ngb-modal-backdrop {
  z-index: 1050 !important;
}

:host ::ng-deep .iti {
  position: relative;
  display: inline-block;
  width: 100%;
}

.background {
  width: calc(100% - 600px);
  background-size: cover;
  background-position: right -140px top;
}

.inputs-container {
  max-width: 600px;
  padding: 50px;
}

.form-group {
  margin-bottom: 0.5rem;
}

.input-lowercase {
  text-transform: lowercase;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/registration/registration.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AACF;;AAEA;EACI,yBAAA;EACA,sBAAA;EACA,qCAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACE,yBAAA;AACF","sourcesContent":["::ng-deep ngb-modal-backdrop {\n  z-index: 1050 !important;\n}\n\n:host ::ng-deep .iti {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.background {\n    width: calc(100% - 600px);\n    background-size: cover;\n    background-position: right -140px top;\n}\n\n.inputs-container {\n    max-width: 600px;\n    padding: 50px;\n}\n\n.form-group {\n    margin-bottom: .5rem;\n}\n\n.input-lowercase {\n  text-transform: lowercase;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
